<template>
  <div class="prepare-question__downanswer">
    <div class="answer__body">
      <div v-for="(item, index) of questionDetail.answers" :key="index" class="answer display-flex justify-content-between">
        <div class="answer__left">
          <div class="form-item">
            <label class="display-block">Nội dung câu trả lời <span class="color-err">*</span></label>
            <div
              class="form-item__editor"
              :class="{ 'form-item-err': isSubmit && (!item.content || (item.content && item.content === contentDefault)) }"
            >
              <EdittorCKAnswer 
                :contentEditor="questionDetail.answers[0].content"
                :position="'0_' + indexQuestionWorking"
              />
            </div>
            <div v-if="isSubmit && (!item.content || (item.content && item.content === contentDefault))" class="form-item__noti color-err font-size-15 mt-2">
              Bạn hãy nhập vào nội dung
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STORE_KEY, CONTENT_EDITOR_DEFAULT } from './../../_store/constants'
import EdittorCKAnswer from '@/modules/question/EdittorCKAnswer.vue'
import mixinsQuestions from './../../_store/mixinsQuestions'
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'QuestionDownAnswer',
  mixins: [ mixinsQuestions ],
  props: {
    isSubmit: Boolean
  },
  components: {
    EdittorCKAnswer
  },
  data () {
    return {
      uploadUrl: APP_CONFIG.uploadUrl,
      cdnUrl: APP_CONFIG.cdnUrl,
      contentDefault: CONTENT_EDITOR_DEFAULT
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['questionDetail', 'indexQuestionWorking'])
  },
  mounted () {
    this.initQuestion()
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetQuestionDetail']),

    initQuestion () {
      if ((!this.questionDetail.questionId || this.questionDetail.questionId === 0) && this.questionDetail.answers.length === 0) {
        this.questionDetail.answers.push({content: '', correct: '', answerId: 0, isNew: true})
        this.acSetQuestionDetail({...this.questionDetail})
      }
    }
  }
}
</script>

<style>

</style>